import { useEffect, useState } from "react";
import QuestionForm from "../common/QuestionForm/QuestionForm";
import { giveAnswer } from '../../utils/giveAnswer'
import styles from "./Module5.module.scss"

// render the MOD section of Module 5 (Step 6) of the full survey; called by Module5.js
const Module5MOD = ({ questions, previousAnswers, updateProgress, updateAnswers }) => {

  const [answerObj, setAnswerObj] = useState({}) // future object like { "MOD1a": 5, "MOD1b": 2, ...}

  useEffect(() => {
    /* set up initialAnswerObj: { "MOD1a": null, "MOD1b": null, ...} */
    const initialAnswerObj = {}
    questions.forEach(question => initialAnswerObj[question.questionID] = null)

    /* if previous answers exist, update initialAnswerObj */
    if (Object.keys(previousAnswers).length) {
      for (const questKey in initialAnswerObj) {
        if (previousAnswers[questKey]) initialAnswerObj[questKey] = previousAnswers[questKey]
      }
      // also update progress bar
      updateProgress(Object.values(previousAnswers).filter(answer => answer !== null).length, 'MOD')
    }
    setAnswerObj(initialAnswerObj);
    updateAnswers(initialAnswerObj); // send answers to Module5.js for saving in DB

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[previousAnswers])

  return (<div>
    {Object.keys(answerObj).length && questions.map((question, idx) => {
      return <div key={question.questionID}>
        <QuestionForm
          question1={question.question1}
          question2={question.question2}
          questionIndex={idx}
          questionFormat={question.format}
          answerLabels={question.answerLabels || 'default'}
          currentAnswer={answerObj[question.questionID]}
          giveAnswer={(val, questionIndex) => giveAnswer(
            'MOD', val, questionIndex, null, questions,
            answerObj, setAnswerObj, updateAnswers, updateProgress,
          )}
        />
        <hr className={styles.horizontalLine}></hr>
      </div>
    })}
  </div>)
}

export default Module5MOD;
